import React, { createContext, useContext, useState } from 'react';

interface ViewsProviderProps {
    children: React.ReactNode;
}

interface ViewContextProps {
    currentView: string;
    changeView: (view:string) => void;
}

const ViewsContext = createContext<ViewContextProps | undefined>(undefined); 

export const ViewProvider:React.FC<ViewsProviderProps> = ({ children }) => {
  const [currentView, setcurrentView] = useState("");

  const changeView = (view: string) => {
    setcurrentView(view);
  };

  return (
    <ViewsContext.Provider value={{ currentView, changeView }}>
      {children}
    </ViewsContext.Provider>
  );
};

export const useView = (): ViewContextProps => {
    const context = useContext(ViewsContext);
    if (!context) {
        throw new Error("useView must be used within a ViewProvider");
    }
    return context;
}